import React, { Fragment } from 'react';
import { Box, Grid, Skeleton, Typography } from '@mui/material';
import _ from 'lodash';

interface FoodPriceListSkeletonProps {
}

const FoodPriceListSkeleton: React.FC<FoodPriceListSkeletonProps> = ({ }) => {
    return (
        <Grid mt={0.8}>
            <Box display={"flex"} gap={3} alignItems={"flex-end"} height={29.69}>
                <Fragment >
                    <Box>
                        <Typography
                            variant='subtitle2'
                            color={"#f7c147"}
                            fontWeight={600}
                            lineHeight={1.2}>
                            <Skeleton width={40} />
                        </Typography>
                    </Box>
                </Fragment>
            </Box>
        </Grid>
    )
}

export default FoodPriceListSkeleton;